import { getFirestore } from "firebase/firestore"; //@adhilsalim
import { firebaseConfig } from "firebaseconfig";
import { initializeApp } from "firebase/app";
import { getAuth, signInWithEmailAndPassword, sendPasswordResetEmail } from "firebase/auth";
import { func } from "prop-types";

export async function OnUserRequestLogin(email, password) {
  const auth = getAuth();
  const credentials = await signInWithEmailAndPassword(auth, email, password);
  const idTokenResult = await credentials.user.getIdTokenResult();
  console.log("claims: ", idTokenResult.claims);
  return credentials;
}

export function isUserLoggedIn() {
  const user = getAuth().currentUser;
  return !!user;
}

export async function OnUserLogout() {
  const auth = getAuth();
  await auth.signOut();
}

export function ResetPassword(email) {
  const auth = getAuth();
  return sendPasswordResetEmail(auth, email);
}

//@adhilsalim
export async function createUserAccountWithEmailAndPassword(name, email, password) {
    const db = getFirestore();
    const firebaseTempApp = initializeApp(firebaseConfig, "firebaseTempApp");
    const userCredential = await firebaseTempApp.auth().createUserWithEmailAndPassword(email, password);
    const user = userCredential.user;

    await db.collection('users').doc(user.uid).set({
        email: user.email,
        name: name
    });

    await firebaseTempApp.auth().signOut();
    firebaseTempApp.delete()
}
